import styled from "styled-components";
import { ColorsInterface } from "@/theme/colors";
import { mobile } from "@/theme/common";

/**
 * H2 Component
 */

export const H2 = styled.h2<ColorsInterface & { fontSize?: number }>`
  ${({ color = "black", theme, fontSize = 28 }) => `
  color: ${theme.Colors[color]};
  font-family: ${theme.Fonts.ttNormsProBold};
  font-size: ${fontSize}px;
  line-height: 36px;
  ${mobile(`
    font-size: 24px;
    line-height: 32px;
  `)}
  `}
`;
